//
// TLS Dose Engine Machine page
//
import { useState, useEffect } from "react";

import gSession from '../script/session.js';
import gUtilities from '../script/utilities';

import TableWidget from './TableWidget';

// if useState() then this oscillates!
let machine = null;
function setMachine(m) {
    machine = m;
}

const MachinesPage = () => {
    const [machines, setMachines] = useState(null);
    const [collimators, setCollimators] = useState(null);

    function toMachineTable(data) {
        let table = {
            columns: ["name", "status", "serial_number", "description"],
            titles: ["Name", "Status", "Serial Number", "Description"],
            data: data.list
        };

        setMachines(table);
    }

    function updateMachine(data) {
        if (machine) {
            for (let amachine of data.list) {
                if (amachine.name === machine.name) {
                    assignMachine(amachine);
                    break;
                }
            }
        }
    }

    function onSelectMachine(amachine) {
        assignMachine(amachine);
    }

    function assignMachine(amachine) {
        let table = {
            columns: ["name", "status", "size", "length"],
            titles: ["Name", "Status", "Size (cm)", "Length (cm)"],
            data: []
        };

        for (let collimator of amachine.collimators) {
            table.data.push(collimator);
        }

        setMachine(amachine);
        setCollimators(table);
    }

    async function getMachines() {
        let request = {
            service: "db.query",
            collection: "dcs_machine",
            many: true,
            query: {}
        };

        let response = await gSession.exchange(request);

        if (response.isError) {
            gUtilities.showError("Machines", response.message);
        } else {
            toMachineTable(response);
            updateMachine(response);
        }
    }

    function machineRowClass(row) {
        if (row && machine && row.name === machine.name) {
            return "table-success";
        } else {
            return "table-light";
        }
    };

    function collimatorRowClass(row) {
        return "table-light";
    };

    function scheduleUpdate() {
        let id = setTimeout(async () => {
            try {
                await getMachines();
            } catch (ex) {
                console.log("ERROR: [EXCEPTION] Machine data - ", ex);
            }
        }, 1000);

        return id;
    }

    useEffect(() => {
        let timer_id = scheduleUpdate();

        // cleanup function: stop updates.
        return () => {
            clearTimeout(timer_id);
        };
    }, [machines]);

    return (
        <div id="w_MachinesPageRootDiv">
            <div>
                {machines &&
                    <div>
                        <h2>Machines</h2>
                        <TableWidget name="machines" data={machines.data} columns={machines.columns} titles={machines.titles} rowClassFunction={machineRowClass} rowSelectCallback={onSelectMachine} />
                    </div>
                }

                <br></br>
                {collimators &&
                    <div>
                        <h2>Collimators for Machine {machine.name}</h2>
                        <TableWidget name="collimators" data={collimators.data} columns={collimators.columns} titles={collimators.titles} rowClassFunction={collimatorRowClass} />
                    </div>
                }
            </div>
        </div >
    );
}

export default MachinesPage;